import Service from "../Service";

function GetDivisionByUniversityId() {
    return Service.get('PublicPage/GetDivisions');
}

function GetDepartmentByDivisionId() {
    return Service.get(`PublicPage/GetDepartments`);
}

const DivisionService = {
    GetDivisionByUniversityId,
    GetDepartmentByDivisionId
}

export default DivisionService;